<template lang="html">
  <div>    
    <setup-branch-profile-edit-form  
      v-show="showProfile" 
      :branch-uid="selectedBranchUid"
      @updated="getBranchList()"
    >
      <template v-slot:breadcrumb>
        <v-breadcrumbs 
          :items="items" 
          divider="/"
        >
          <template v-slot:item="props">
            <v-breadcrumbs-item :class="[props.item.disabled && 'disabled']">
              <a 
                :class="[props.item.disabled && 'disabled']"
                @click="closeBranchProfile()"
              >{{ props.item.text }}</a>
            </v-breadcrumbs-item>
          </template>        
        </v-breadcrumbs>
      </template>
    </setup-branch-profile-edit-form>

    <v-container 
      v-show="!showProfile" 
      fluid
    >
      <v-row>
        <v-col cols="12">
          <v-card class="elevation-5">
            <v-toolbar
              flat
              color="white"
            >
              <v-text-field
                v-model="searchInput"
                append-icon="search"
                autofocus
                placeholder="Search by Branch Name, Address, or City"
                single-line
                hide-details
                clearable
              />

              <v-checkbox
                v-if="!$vuetify.breakpoint.smAndDown"
                v-model="hideOmBic"
                label="Hide OM/BIC"
                class="mt-6 ml-2"
                required
              />
              <v-spacer />

              <setup-branch-dialog-create
                v-if="this.$hasPermissionTo(['create branches'])"
                @updated="getBranchList()"
              />

              <v-tooltip
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-avatar 
                    class="cursor-pointer"
                    v-on="on"   
                    @click="getBranchList"             
                  >
                    <v-icon medium>
                      mdi-refresh
                    </v-icon>
                  </v-avatar>
                </template>
                <span>Reload</span>
              </v-tooltip>
            </v-toolbar>
            <v-data-table
              :loading="tableLoading"
              :headers="filteredHeaders"
              :items="branches"
              hide-default-footer
            > 
              <v-progress-linear
                v-slot:progress
                color="blue"
                indeterminate
              />
              <template v-slot:item.branch_name="{ item }">
                <a 
                  class="font-weight-bold light-blue--text  text--darken-3" 
                  @click="showBranchProfile(item.branch_uid)"
                >
                  {{ item.branch_name }}
                </a>
              </template>
              <template v-slot:item.operation_manager="{ item }">
                {{ item.operation_manager ? item.operation_manager.name : '' }}
              </template>
              <template v-slot:item.user_in_charge="{ item }">
                {{ item.user_in_charge ? item.user_in_charge.name : '' }}
              </template>
            </v-data-table>
            <v-divider class="ml-0 mr-0" />
            <v-container class="text-right">
              <v-btn
                icon
                color="primary"
                :disabled="currentPage === 1"
                @click="previousPage"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <span class="pagination">{{ from }}-{{ to }} of {{ total }}</span>
              <v-btn
                icon
                color="primary"
                :disabled="currentPage === lastPage"
                @click="nextPage"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-container>
          </v-card> 
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    components: {
      SetupBranchProfileEditForm: () => import('@/components/setup/branch/ProfileEditForm'),
      SetupBranchDialogCreate: () => import('@/components/setup/branch/DialogCreate'),
    },
    data: () => ({
      headers: [
        {
          text: 'Branch Name',
          align: 'left',
          value: 'branch_name',
          sortable: false,
        },
        {
          text: 'Address',
          align: 'left',
          value: 'branch_address',
          sortable: false,
        },
      ],
      tableLoading: false,
      branches: [],
      selectedBranchUid: null,
      showProfile: false,
      items: [
        {
          text: 'Branch',
          disabled: false,
          closeProfile: true,
        },
        {
          text: 'Profile',
          disabled: true,
        
        },
      ],
      searchInput: '',
      hideOmBic: false,
      total: 0,
      from: 0,
      to: 0,
      lastPage: 0, 
      currentPage: 1,
    }),
    computed: {
      filteredHeaders () {
        return this.hideOmBic === false ? [
          ...this.headers, 
          {
            text: 'OM',
            align: 'left',
            value: 'operation_manager',
            sortable: false,
          },
          {
            text: 'BIC',
            align: 'left',
            value: 'user_in_charge',
            sortable: false,
          },
        ] : this.headers
      },
    },
    watch: {
      searchInput (val) {
        clearTimeout(this._searchTimerId)
        this._searchTimerId = setTimeout(() => {
          this.tableLoading = true
          this.getBranchList()
        }, 500) /* 500ms throttle */
      },
    },
    mounted () {
      this.getBranchList()
      if (this.$vuetify.breakpoint.smAndDown) {
        this.hideOmBic = true
      }
    },  
    methods: {  
      closeBranchProfile () {
        this.showProfile = false
      },
      showBranchProfile (branchUid) {
        this.selectedBranchUid = branchUid
        this.showProfile = true
      },
      getBranchList () {
        this.tableLoading = true
        this.$api.branches().overview('', this.prepareFormData())
          .then((res) => {
            this.setPaginationDetails(res.data)
            this.branches = res.data.data
          })
          .then(() => {
            this.tableLoading = false
          })
      },
      updatePage () {
        // let currentEmployeeUid = this.employee.employee_uid

        this.$api.branches().overview('?page=' + this.currentPage, this.prepareFormData())
          .then(res => {
            // this.$set(this.employees, this.employees.findIndex(employee => employee.employee_uid === currentEmployeeUid), response.data)
          
            this.$refs.searchInput.focus() 
            this.branches = res.data.data
          })

        this.isProfile = false
      },
      nextPage () {
        this.tableLoading = true

        this.$api.branches().overview('?page=' + (this.currentPage + 1), this.prepareFormData())
          .then(res => {
            this.branches = res.data.data
            this.setPaginationDetails(res.data)
    
            this.tableLoading = false
          })
      },
      previousPage () {
        this.tableLoading = true

        this.$api.branches().overview('?page=' + (this.currentPage - 1), this.prepareFormData())
          .then(res => {
            this.branches = res.data.data
            this.setPaginationDetails(res.data)
    
            this.tableLoading = false
          })
      },
      prepareFormData () {
        return {
          searchInput: this.searchInput,
        }
      },
      setPaginationDetails (page) {
        this.total = page.total
        this.from = page.from
        this.to = page.to
        this.lastPage = page.last_page
        this.currentPage = page.current_page
      },
    },
  }
</script>

<style lang="css" scoped>
  .disabled {
    color: grey;
    pointer-events: none;
  }
  
</style>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-rating .v-icon{
    padding:0px;
  }

  ::v-deep .v-rating {
    width:50px;
  }
  
  v-table__overflow{
    overflow-x:hidden;
  }

  .horizontal-scroll{
    overflow-x:hidden; 
    overflow-y:hidden; 
    width:50vw;
  }

  .horizontal-scroll-xl{
    overflow-x:hidden; 
    overflow-y:hidden; 
    width:20vw;
  }

  .cursor-pointer{
    cursor: pointer;
  }
</style>
